var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown-item',{on:{"click":_vm.openVersions}},[_vm._v("Changelog")])
}
var staticRenderFns = []

export { render, staticRenderFns }